import { formatMoney as shopifyFormatMoney } from '@shopify/theme-currency'

const settings = window.GM_STATE

const formatMoney = function (cents, format = settings.shopify.moneyFormat) {
  return shopifyFormatMoney(cents, format)
}

const formatMoneyWithoutDecimals = function (cents, format = settings.shopify.moneyFormatWithoutDecimals) {
  return shopifyFormatMoney(cents, format)
}

const getCustomBadgeClass = (tag) => {
  return tag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
}

const getBadges = (tags) => {
  const items = []

  if (tags.length) {
    for (const tag of tags) {
      if (tag.includes('label-')) {
        const tagName = tag.replace('label-', '')

        items.push({
          text: tagName,
          tag,
          customClass: getCustomBadgeClass(tag)
        })
      }
    }
  }

  return items
}

const getPriceSubscription = (planGroups, price) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let priceSubscription = price

  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      priceSubscription = priceSubscription - priceSubscription * priceAdjustment.value / 100
    } else {
      priceSubscription = priceSubscription - priceAdjustment.value
    }
  }

  return priceSubscription
}

const getSubscriptionSave = (planGroups) => {
  const planGroup = planGroups?.find(Boolean)
  const sellingPlans = planGroup?.selling_plans
  const priceAdjustments = sellingPlans?.find(Boolean).price_adjustments
  const priceAdjustment = priceAdjustments?.find(Boolean)
  let subscriptionSave = null

  if (priceAdjustment?.value > 0) {
    if (priceAdjustment.value_type === 'percentage') {
      subscriptionSave = `${priceAdjustment.value}%`
    } else {
      subscriptionSave = `${formatMoney(priceAdjustment.value)}`
    }
  }

  return subscriptionSave && `Subscribe & Save ${subscriptionSave}`
}

const formatAsPercentage = (number) => {
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(number / 100)
}

const addBadgeSale = (badges, price, originalPrice) => {
  if (price && originalPrice && price < originalPrice) {
    const text = 'Sale'

    badges.unshift({
      text,
      tag: 'label-sale',
      customClass: 'label-sale'
    })
  }

  return badges
}

const formatUnitSize = (size) => {
  return `${size}${sizeUnit}`
}

const formatRangeSize = (values) => values && values.map(item => formatUnitSize(item)).join(' - ')

const formatRangePrice = (values) => values && values.map(item => formatMoney(item * 100)).join(' - ')

const getDefaultImage = (img) => {
  return (Array.isArray(img) && img.length === 0) || !img ? GM_STATE.shopify.defaultImage : img
}

const getGraphQLID = (id, type) => `gid://shopify/${type}/${id}`

const getGraphQLIds = (ids, type) => {
  if (ids.length === 0) return []

  return ids.map((id) => getGraphQLID(id, type))
}

function convertPrice(price) {
  return typeof price === 'string' ? parseFloat(price) : price
}

function getPrice(price) {
  return price ? convertPrice(price) * 100 : 0
}

export {
  formatMoney,
  getBadges,
  getCustomBadgeClass,
  getPriceSubscription,
  getSubscriptionSave,
  addBadgeSale,
  formatUnitSize,
  formatRangeSize,
  formatRangePrice,
  getDefaultImage,
  getGraphQLIds,
  getGraphQLID,
  getPrice,
  formatMoneyWithoutDecimals
}
